export default "__VITE_PUBLIC_ASSET__244cd4d3__"